export default __webpack_public_path__ + "static/media/ticket-creation-error.fb303d90.png";